// 随访记录
export default [
	{
		path: '/followUp/list/:id?',
		name: 'followUpList',
		component: () => import('@/views/follow-up/list.vue'),
		meta: { title: '随访记录' }
	},
	{
		path: '/plan/list/:id?',
		name: 'planList',
		component: () => import('@/views/plan/list.vue'),
		meta: { title: '复诊计划' }
	}
]
